import React from 'react';
import { CheckIcon, LockIcon } from 'lucide-react';
import { product } from '../data/product';
import { bonuses } from '../data/bonuses';
import { checkoutUrl } from '../data/checkout';
import { trackInitiateCheckout } from '../utils/metaPixel';
import { useCountdown } from '../hooks/useCountdown';
export function Offer() {
  const time = useCountdown();
  const total = [product, ...bonuses].reduce((sum, item) => sum + item.value, 0);
  return <section id="offre" className="scroll-mt-12 px-4 py-16 sm:px-5 sm:py-20 md:py-28" aria-labelledby="offre-title" data-id="element-143" data-mp="u0xt3ootfuza">
      <div className="mx-auto max-w-3xl text-center" data-id="element-144" data-mp="13x14zm9gz7zf">
        <h2 id="offre-title" className="font-display text-4xl uppercase leading-none text-cream md:text-6xl" data-id="element-145" data-mp="13xst6c0qm3fo">
          Obtenez le pack complet <span className="text-gold" data-id="element-146" data-mp="z0apb01kueej">aujourd’hui</span>
        </h2>
        <p className="mt-5 font-serif text-lg italic text-cream-muted" data-id="element-147" data-mp="2famrt0ruwxhs">
          Une seule fois. Accès à vie. Aucun abonnement.
        </p>
      </div>

      <div className="mx-auto mt-10 max-w-3xl overflow-hidden rounded-2xl sm:mt-12 sm:rounded-3xl border border-gold/40 bg-ink-soft" data-id="element-148" data-mp="pkh4r5ywamdk">
        <div className="grid md:grid-cols-[1.3fr_1fr]" data-id="element-149" data-mp="ui0k697bx573">
          <div className="order-2 p-6 sm:p-8 md:order-1 md:p-10" data-id="element-150" data-mp="zio98pbzzbyo">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gold" data-id="element-151" data-mp="zj6hkkbxpgmy">Tout ce que vous recevez</p>
            <ul className="mt-5 space-y-3" data-id="element-152" data-mp="13hnlyw3z0d0o">
              {[{
              label: `${product.name} — le système complet`,
              value: product.value
            }, ...bonuses.map((b, i) => ({
              label: `Bonus ${i + 1} : ${b.name}`,
              value: b.value
            }))].map(item => <li key={item.label} className="flex items-start justify-between gap-4 text-sm" data-id="element-153" data-mp="ftm7l6k422dc">
                    <span className="flex gap-2 text-cream/90" data-id="element-154" data-mp="klxkrb3v3knu">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-155" data-mp="3k8vvmv4tcyel" />
                      {item.label}
                    </span>
                    <span className="shrink-0 text-cream-muted" data-id="element-156" data-mp="3o84lhowqgc4v">{item.value} $</span>
                  </li>)}
            </ul>
          </div>

          <div className="order-1 flex flex-col items-center justify-center border-b border-ink-line bg-club p-6 text-center sm:p-8 md:order-2 md:border-b-0 md:border-l md:p-10" data-id="element-157" data-mp="qfurvzil1fb2">
            <p className="text-sm text-cream-muted" data-id="element-158" data-mp="10679biv3oscz">
              Valeur totale : <s data-id="element-159" data-mp="cgv40u2w94fy">{total} $</s>
            </p>
            <p className="mt-2 text-sm font-semibold uppercase tracking-[0.15em] text-gold" data-id="element-160" data-mp="chxw35bydcxg">Aujourd’hui seulement</p>
            <p className="mt-1 font-display text-7xl leading-none sm:text-8xl text-cream" data-id="element-161" data-mp="7jct4y5bgf5b">27 $</p>
            <p className="mt-2 text-xs text-cream-muted" data-id="element-162" data-mp="lj4cleelqnqp">Paiement unique</p>
            <a href={checkoutUrl || '#offre'} onClick={trackInitiateCheckout} className="mt-6 w-full rounded-full bg-gold px-6 py-4 font-bold text-ink transition-[background-color,transform] duration-150 ease-out hover:bg-gold-soft active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-soft focus-visible:ring-offset-2 focus-visible:ring-offset-club" data-id="element-163" data-mp="hewljako8vpb">
              Je commande maintenant
            </a>
            <p className="mt-4 flex items-center gap-1.5 text-xs text-cream-muted" data-id="element-164" data-mp="1qh9etfdz2sdz">
              <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-165" data-mp="1vf1401n8g0eh" />
              Paiement 100 % sécurisé
            </p>
            <p className="mt-4 text-xs text-cream-muted" data-id="element-166" data-mp="2j66iodhfsmn7">
              L’offre expire dans <span className="font-semibold tabular-nums text-gold" data-id="element-167" data-mp="2o4rkuig91gea">{time}</span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}